import { render, staticRenderFns } from "./SelectShift.vue?vue&type=template&id=0ccddc9a"
import script from "./SelectShift.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectShift.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccddc9a')) {
      api.createRecord('0ccddc9a', component.options)
    } else {
      api.reload('0ccddc9a', component.options)
    }
    module.hot.accept("./SelectShift.vue?vue&type=template&id=0ccddc9a", function () {
      api.rerender('0ccddc9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/shift/components/SelectShift.vue"
export default component.exports